import React, { useState, useEffect, useRef } from 'react';
import { useLocation, Link } from 'react-router-dom';
import logo from '../assets/here4u_180x180.png';
import './Menu.css';

function Menu() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const menuRef = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="LogoMenu-container" ref={menuRef}>
      <img
        src={logo}
        className="LogoMenu-image"
        alt="Here4U Logo"
        onClick={() => setIsOpen(!isOpen)}
      />
      {isOpen && (
        <div className="LogoMenu-dropdown">
          <ul className="LogoMenu-list">
            {location.pathname !== '/' && (
              <li>
                <Link to="/Home" className="LogoMenu-link">
                  <i className="fa-solid fa-house" /> Home
                </Link>
              </li>
            )}
            {location.pathname !== '/ContactUs' && (
              <li>
                <Link to="/ContactUs" className="LogoMenu-link">
                  Contact Us
                </Link>
              </li>
            )}
            {location.pathname !== '/PrivacyPolicy' && (
              <li>
                <Link to="/PrivacyPolicy" className="LogoMenu-link">
                  Privacy Policy
                </Link>
              </li>
            )}
            <li>
              <a
                href="https://survivor.here4u.care"
                target="_blank"
                rel="noopener noreferrer"
                className="LogoMenu-link"
              >
                Survivor Support
              </a>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}

export default Menu;